import Button from '@mui/material/Button'
import { IQDialog, Preloader } from '../../common'
import Typography from '@mui/material/Typography'
import { Stack } from '@mui/material'

interface IProps {
  isShow: boolean
  disableCreateAnotherButton?: boolean
  title: string
  createAnotherButtonLabel: string
  saveButtonLabel?: string
  isCreatingAnother: boolean
  handleSaveButtonClick: () => void
  handleCancelButtonClick: () => void
  handleCreateAnotherButtonClick?: () => void
  isSavingProcessing: boolean
  dataTestId?: string
}

export const SaveConfirmation = ({
  isShow,
  title,
  disableCreateAnotherButton = false,
  saveButtonLabel,
  createAnotherButtonLabel,
  isCreatingAnother,
  dataTestId,
  handleSaveButtonClick,
  handleCancelButtonClick,
  handleCreateAnotherButtonClick,
  isSavingProcessing,
}: IProps) => {
  const renderCreateActions = () => (
    <Stack
      direction='row'
      spacing={1}
      justifyContent='space-between'
      sx={{ width: '100%' }}
    >
      <Button
        onClick={handleCancelButtonClick}
        data-testid={`${dataTestId}-cancel`}
        variant='outlined'
      >
        Cancel
      </Button>
      <Stack
        direction={'row'}
        spacing={1}
      >
        {!isCreatingAnother ? (
          <></>
        ) : (
          <Button
            disabled={isSavingProcessing || disableCreateAnotherButton}
            variant='contained'
            onClick={handleCreateAnotherButtonClick}
            data-testid={`${dataTestId}-create-another`}
          >
            {createAnotherButtonLabel}
          </Button>
        )}
        <Button
          disabled={isSavingProcessing}
          variant='contained'
          onClick={handleSaveButtonClick}
          data-testid={`${dataTestId}-create`}
        >
          {saveButtonLabel || 'Save'}
        </Button>
      </Stack>
    </Stack>
  )

  return (
    <IQDialog
      isShow={isShow}
      title={''}
      content={
        isSavingProcessing ? (
          <Preloader
            size='sm'
            style={{ display: 'block', margin: '0 auto' }}
          />
        ) : (
          <Typography
            fontWeight='bold'
            fontSize={'20px'}
          >
            {title}
          </Typography>
        )
      }
      actions={renderCreateActions()}
      onClose={handleCancelButtonClick}
      testPrefix={`${dataTestId}-create`}
    />
  )
}
